// The bar's ⏮ / ⏭ through an audition's queue, as the app's
// AuditionController.step (lib/services/sounds/audition.dart): the next or
// previous sound, clamped at the queue's ends (a no-op there, never a
// wrap); from a sound that isn't in the queue, ⏭ plays the first and ⏮
// the last. The bar keeps both live for any sound list (sounds_browser
// .dart passes onPrev / onNext unconditionally); only a preview with no
// list behind it (Discover's mixdown) has neither.

/** The index to play next, or -1 when the step does nothing. */
export function stepTarget(index, length, back = false) {
  const n = Number(length) || 0;
  if (n <= 0) return -1;
  const i = Number.isInteger(index) && index >= 0 && index < n ? index : -1;
  const next = i < 0 ? (back ? n - 1 : 0) : Math.min(n - 1, Math.max(0, i + (back ? -1 : 1)));
  return next === i ? -1 : next;
}

/** Whether the bar's ⏮ and ⏭ are live: a sound, or anything with a queue. */
export function canStep({ queueLength = 0, isSound = false } = {}) {
  return isSound || queueLength > 0;
}
